module.exports = __webpack_public_path__ + "img/iso_9001.698c412c.jpg";